import { defineStore, type StateTree } from 'pinia';
import { StationVisibilityOptions } from '../../site-details/enums';
import type { SitePrivateConfig, StationBrand, StationPublicConfig } from '@centric-os/types';

interface State extends StateTree {
  stationVisibilityFilter: StationVisibilityOptions;
  stationBeingEdited: StationBrand;
  publicConfigBeingEdited: StationPublicConfig;
  privateConfigBeingEdited: SitePrivateConfig;
  isTimeslotTransition: boolean;
  isEditingTimeslotStation: boolean;
  locationIdBeingEdited: string | null;
}

export function useSiteDetailsStore(storeId = 'siteDetails') {
  const store = defineStore(storeId, {
    state: (): State => ({
      stationVisibilityFilter: StationVisibilityOptions.ALL,
      stationBeingEdited: null,
      publicConfigBeingEdited: null,
      privateConfigBeingEdited: null,
      isTimeslotTransition: false,
      isEditingTimeslotStation: false,
      locationIdBeingEdited: null,
    }),
    actions: {},
    pagination: false,
  });
  return store();
}
